import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-3">
            {t('categories_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden aspect-square bg-stone-100 hover:shadow-md transition-all"
            >
              <img
                src={cat.image}
                alt={t(cat.nameKey)}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-2 md:p-3">
                <span className="text-xs md:text-sm font-medium text-white block truncate">
                  {t(cat.nameKey)}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
          >
            <i className="ri-external-link-line" />
            CSSBuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium bg-stone-800 text-white rounded-lg hover:bg-stone-900 transition-colors"
          >
            <i className="ri-shopping-bag-line" />
            {t('btn_buy_it_now')}
          </a>
        </div>
      </div>
    </section>
  );
}